import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <div className="bg-white min-h-[70vh] flex flex-col items-center justify-center px-6 py-12 text-center">
      <SEO title="404 Side Ikke Fundet - Dansketelemaster Invest" description="Siden blev ikke fundet." />
      
      <div className="max-w-md space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-50 text-[#2a4692] mb-2">
          <i className="fa-solid fa-triangle-exclamation text-4xl" />
        </div>
        
        <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight">
          404 - Siden blev ikke fundet
        </h1>
        
        <p className="text-slate-600 leading-relaxed">
          Beklager, men siden du leder efter findes ikke, er blevet flyttet eller er midlertidigt utilgængelig.
        </p>
        
        <div className="pt-4">
          <Link
            to="/"
            className="bg-[#2a4692] hover:bg-[#1d3166] text-white font-bold px-6 py-3 rounded-md transition-all inline-flex items-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-house text-sm" />
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
